"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3125],{

/***/ 14538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opendoor_shared_fe_store_session_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5868);
/* harmony import */ var _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30405);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37796);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30633);




var mapStateToProps = (0,reselect__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)([
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .human */ .y1,
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .infoIsLoaded */ .Jv,
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .infoIsLoading */ .p6,
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .loggedIn */ .Pl,
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .loginRequestStatus */ .et,
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .humanStatusRequestStatus */ .tH,
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .registrationRequestStatus */ .jo,
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .serverLoginRedirect */ .xu,
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .email */ .Do,
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .hasGeneratedPassword */ .PQ,
    _opendoor_shared_fe_store_session_selectors__WEBPACK_IMPORTED_MODULE_3__/* .isNewHuman */ .oq, 
], function(human, infoIsLoaded, infoIsLoading, loggedIn, loginRequestStatus, humanStatusRequestStatus, registrationRequestStatus, serverLoginRedirect, email, hasGeneratedPassword, isNewHuman) {
    return {
        human: human,
        infoIsLoaded: infoIsLoaded,
        infoIsLoading: infoIsLoading,
        loggedIn: loggedIn,
        loginRequestStatus: loginRequestStatus,
        humanStatusRequestStatus: humanStatusRequestStatus,
        registrationRequestStatus: registrationRequestStatus,
        serverLoginRedirect: serverLoginRedirect,
        email: email,
        hasGeneratedPassword: hasGeneratedPassword,
        isNewHuman: isNewHuman
    };
});
var mapDispatchToProps = function(dispatch) {
    return {
        maybeFetchSessionInfo: function() {
            dispatch(_opendoor_shared_fe_store_session_actions__WEBPACK_IMPORTED_MODULE_0__/* .maybeFetchSessionInfo */ .d3());
        },
        maybeLogOut: function() {
            dispatch(_opendoor_shared_fe_store_session_actions__WEBPACK_IMPORTED_MODULE_0__/* .maybeLogOut */ .aO());
        },
        logIn: function(email, password, googleIDToken, facebookIDToken) {
            dispatch(_opendoor_shared_fe_store_session_actions__WEBPACK_IMPORTED_MODULE_0__/* .logIn */ .Ib(email, password, googleIDToken, facebookIDToken));
        },
        requestHumanStatus: function(email) {
            dispatch(_opendoor_shared_fe_store_session_actions__WEBPACK_IMPORTED_MODULE_0__/* .requestHumanStatus */ .by(email));
        },
        requestResetPassword: function(email) {
            dispatch(_opendoor_shared_fe_store_session_actions__WEBPACK_IMPORTED_MODULE_0__/* .requestPasswordReset */ .f8(email));
        },
        register: function(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl) {
            dispatch(_opendoor_shared_fe_store_session_actions__WEBPACK_IMPORTED_MODULE_0__/* .register */ .z2(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl));
        }
    };
};
/**
 * This is an HOC that provides access to the session state via props
 *
 * @deprecated Use @opendoor/auth-fe::useAuth instead
 */ var AccountConnector = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ __webpack_exports__["Z"] = (AccountConnector);


/***/ }),

/***/ 28432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ BricksNextLoader; }
/* harmony export */ });
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5984);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Client-only wrapper for the bricks-next Loader.
 *
 * The bricks-next Loader uses lottie-react-native which requires DOM APIs
 * and cannot render during SSR. This wrapper uses next/dynamic with ssr: false
 * to ensure it only renders on the client.
 */ var BricksNextLoader = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3985), __webpack_require__.e(2211), __webpack_require__.e(5959), __webpack_require__.e(820), __webpack_require__.e(8806), __webpack_require__.e(2063), __webpack_require__.e(8948), __webpack_require__.e(7154), __webpack_require__.e(9183), __webpack_require__.e(2040), __webpack_require__.e(3477), __webpack_require__.e(8092), __webpack_require__.e(4319), __webpack_require__.e(2276), __webpack_require__.e(641), __webpack_require__.e(5370), __webpack_require__.e(5170), __webpack_require__.e(9049), __webpack_require__.e(4787), __webpack_require__.e(8872)]).then(__webpack_require__.bind(__webpack_require__, 38872)).then(function(mod) {
        return mod.Loader;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38872)
            ];
        }
    },
    ssr: false
});


/***/ }),

/***/ 49957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36690);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5108);



var Divider = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        tag: "hr",
        margin: 0,
        borderWidth: 0,
        borderTopWidth: 1,
        borderStyle: "solid",
        borderColor: "$borderSecondary",
        width: "100%"
    }, props));
};


/***/ }),

/***/ 82219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_ReduxWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/http-client@4.3.1/node_modules/http-client/index.js
var http_client = __webpack_require__(68683);
// EXTERNAL MODULE: ../../node_modules/.pnpm/js-cookie@2.1.4/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(37462);
;// CONCATENATED MODULE: ../shared-fe/es/api/session.mjs


//#region src/api/session.ts
var ResponseError = class extends Error {
	response;
	constructor(message, response) {
		super(message);
		this.response = response;
	}
};
var SessionApi = class {
	BASE_URL = "/api/v1";
	commonStack;
	constructor(cookieKey, railsUrl) {
		this.commonStack = () => (0,http_client/* createStack */.fg)((0,http_client/* init */.S1)("credentials", "include"), (0,http_client/* accept */.RL)("application/json"), (0,http_client/* header */.Fs)("Content-Type", "application/json"), (0,http_client/* header */.Fs)("X-CSRF-Token", js_cookie.get(cookieKey)), (0,http_client/* base */.ue)(railsUrl));
		Object.getOwnPropertyNames(Object.getPrototypeOf(this)).filter((key) => key !== "constructor").forEach((key) => {
			this[key] = this[key].bind(this);
		});
	}
	doWebGet(url) {
		return (0,http_client/* createFetch */.Fc)(this.commonStack())(url);
	}
	doWebPost(url, jsonParams) {
		return (0,http_client/* createFetch */.Fc)((0,http_client/* createStack */.fg)(this.commonStack(), (0,http_client/* method */.UD)("POST"), (0,http_client/* json */.AV)(jsonParams)))(url);
	}
	doWebPut(url, jsonParams) {
		return (0,http_client/* createFetch */.Fc)((0,http_client/* createStack */.fg)(this.commonStack(), (0,http_client/* method */.UD)("PUT"), (0,http_client/* json */.AV)(jsonParams)))(url);
	}
	doWebDelete(url) {
		return (0,http_client/* createFetch */.Fc)(this.commonStack(), (0,http_client/* method */.UD)("DELETE"))(url);
	}
	doWebApiGet(url, getParams) {
		let stack = (0,http_client/* createStack */.fg)(this.commonStack());
		if (getParams) stack = (0,http_client/* createStack */.fg)(stack, (0,http_client/* params */.f)(getParams));
		return (0,http_client/* createFetch */.Fc)(stack)(`${this.BASE_URL}${url}`);
	}
	async handleResponse(res) {
		const responseMessage = await res.json();
		if (res.ok) return responseMessage;
		throw new ResponseError(`${res.status} ${res.statusText}` + (responseMessage?.error ? ` ${responseMessage.error}` : ""), responseMessage);
	}
	logIn(email, password, googleIDToken, facebookIDToken) {
		return this.doWebPost("/login", {
			human: {
				email,
				password
			},
			google_id_token: googleIDToken,
			facebook_id_token: facebookIDToken
		}).then(this.handleResponse);
	}
	requestHumanStatus(email) {
		return this.doWebApiGet(`/humans/status?email=${encodeURIComponent(email)}`).then(this.handleResponse);
	}
	requestResetPassword(email) {
		return this.doWebPost(`${this.BASE_URL}/humans/reset-password`, { email });
	}
	register(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl) {
		return this.doWebPost("/register", {
			email,
			full_name: name,
			primary_phone: phone,
			password,
			google_id_token: googleIDToken,
			facebook_id_token: facebookIDToken,
			passwordless_token: passwordlessToken,
			has_generated_password: hasGeneratedPassword,
			redirect_url: redirectUrl
		}).then(this.handleResponse);
	}
	logOut() {
		return this.doWebDelete("/logout");
	}
	fetchSessionInfo() {
		return this.doWebGet("/session/info").then((res) => res.json());
	}
	updateHumanInfo(humanId, password, name, phone) {
		return this.doWebPut(`${this.BASE_URL}/humans/${humanId}`, {
			full_name: name,
			primary_phone: phone,
			current_password: password
		}).then((res) => res.json());
	}
};
//#endregion


//# sourceMappingURL=session.mjs.map
// EXTERNAL MODULE: ../observability/dist/chunks/chunk-VIS2X3AA.mjs + 1 modules
var chunk_VIS2X3AA = __webpack_require__(34654);
;// CONCATENATED MODULE: ../shared-fe/es/sagas.mjs

//#region src/sagas.ts
/**
* Users are encouraged to use try/catch clauses in their sagas.
*
* However, if they do not, or an unexpected exception occurs,
* we set up the saga middleware with this handler as the handler
* of last resort:
*
* const sagaMiddleware = createSagaMiddleware({ onError: sagaMiddlewareErrorHandler });
*/
var sagaMiddlewareErrorHandler = (error) => {
	const Sentry = chunk_VIS2X3AA/* globalObservability.getSentryClient */.w.getSentryClient();
	Sentry.withScope?.((scope) => {
		scope.setTag("source", "saga");
		Sentry.captureException?.(error);
	});
};
//#endregion


//# sourceMappingURL=sagas.mjs.map
// EXTERNAL MODULE: ../shared-fe/es/store/session/actionTypes.mjs
var actionTypes = __webpack_require__(91526);
// EXTERNAL MODULE: ../shared-fe/es/store/session/actions.mjs
var actions = __webpack_require__(5868);
// EXTERNAL MODULE: ../../node_modules/.pnpm/immutable@4.0.0-rc.3/node_modules/immutable/dist/immutable.es.js
var immutable_es = __webpack_require__(86023);
;// CONCATENATED MODULE: ../shared-fe/es/store/session/reducer.mjs


//#region src/store/session/reducer.ts
var initialState = (0,immutable_es.fromJS)({
	info: {},
	infoError: void 0,
	infoIsLoaded: false,
	infoIsLoading: true,
	loginRequestStatus: {
		error: void 0,
		isLoading: false
	},
	humanStatusRequestStatus: {
		error: void 0,
		isLoading: false
	},
	registrationRequestStatus: {
		error: void 0,
		isLoading: false
	},
	resetPasswordRequestStatus: {
		error: void 0,
		isLoading: false
	},
	serverLoginRedirect: void 0,
	email: "",
	hasGeneratedPassword: void 0
});
function reducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes/* BEGIN_LOADING_SESSION_INFO */.me: return state.merge({
			infoError: void 0,
			infoIsLoading: true
		});
		case actionTypes/* RECEIVE_SESSION_INFO */.$l: return state.merge({
			info: (0,immutable_es.fromJS)(action.payload.info),
			infoError: void 0,
			infoIsLoaded: true,
			infoIsLoading: false
		});
		case actionTypes/* ERROR_SESSION_INFO */.v3: return state.merge({
			infoError: action.payload.error,
			infoIsLoading: false
		});
		case actionTypes/* BEGIN_LOG_IN */.ji: return state.merge({ loginRequestStatus: {
			error: void 0,
			isLoading: true
		} });
		case actionTypes/* SUCCESS_LOG_IN */.pd: return state.merge({
			loginRequestStatus: {
				error: void 0,
				isLoading: false
			},
			serverLoginRedirect: action.payload.serverLoginRedirect
		});
		case actionTypes/* ERROR_LOG_IN */.wq: return state.merge({ loginRequestStatus: {
			error: action.payload.error,
			statusCode: action.payload.statusCode,
			isLoading: false
		} });
		case actionTypes/* BEGIN_REQUEST_HUMAN_STATUS */.c9: return state.merge({ humanStatusRequestStatus: {
			error: void 0,
			isLoading: true
		} });
		case actionTypes/* SUCCESS_REQUEST_HUMAN_STATUS */.jd: return state.merge({
			humanStatusRequestStatus: {
				error: void 0,
				isLoading: false
			},
			email: action.payload.email,
			hasGeneratedPassword: action.payload.hasGeneratedPassword,
			isNewHuman: action.payload.isNewHuman
		});
		case actionTypes/* ERROR_REQUEST_HUMAN_STATUS */.vH: return state.merge({
			humanStatusRequestStatus: {
				error: action.payload.error,
				statusCode: action.payload.statusCode,
				isLoading: false
			},
			email: action.payload.email,
			hasGeneratedPassword: false
		});
		case actionTypes/* BEGIN_REQUEST_RESET_PASSWORD */.sh: return state.merge({ resetPasswordRequestStatus: {
			error: void 0,
			isLoading: true
		} });
		case actionTypes/* SUCCESS_REQUEST_RESET_PASSWORD */.tD: return state.merge({
			resetPasswordRequestStatus: {
				error: void 0,
				isLoading: false
			},
			email: action.payload.email,
			hasGeneratedPassword: action.payload.hasGeneratedPassword,
			isNewHuman: action.payload.isNewHuman
		});
		case actionTypes/* ERROR_REQUEST_RESET_PASSWORD */.R0: return state.merge({
			resetPasswordRequestStatus: {
				error: action.payload.error,
				statusCode: action.payload.statusCode,
				isLoading: false
			},
			email: action.payload.email,
			hasGeneratedPassword: false
		});
		case actionTypes/* BEGIN_REGISTER */.Hz: return state.merge({ registrationRequestStatus: {
			error: void 0,
			isLoading: true
		} });
		case actionTypes/* SUCCESS_REGISTER */.HS: return state.merge({
			registrationRequestStatus: {
				error: void 0,
				isLoading: false,
				success: true
			},
			serverLoginRedirect: action.payload.serverLoginRedirect
		});
		case actionTypes/* ERROR_REGISTER */.kw: return state.merge({ registrationRequestStatus: {
			error: action.payload.error,
			isLoading: false
		} });
		case actionTypes/* MAYBE_LOG_OUT */.ix: return state.merge({ infoIsLoading: true });
		case actionTypes/* LOGGED_OUT */.E7: return state.merge({
			info: { logged_in: false },
			infoError: void 0,
			infoIsLoaded: true,
			infoIsLoading: false
		});
		default: return state;
	}
}
//#endregion


//# sourceMappingURL=reducer.mjs.map
;// CONCATENATED MODULE: ../shared-fe/es/store/session/index.mjs



//#region src/store/session/index.ts
var session_default = {
	actions: actions/* actions_exports */.NY,
	actionTypes: actionTypes/* actionTypes_exports */.O8,
	initialState: initialState,
	reducer: reducer
};
//#endregion


//# sourceMappingURL=index.mjs.map
;// CONCATENATED MODULE: ../shared-fe/es/isQuotaExceededError.mjs
//#region src/isQuotaExceededError.ts
var isQuotaExceededError = (e) => {
	let quotaExceeded = false;
	if (e) {
		if (e.code) switch (e.code) {
			case 22:
				quotaExceeded = true;
				break;
			case 1014:
				if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
				break;
			default: break;
		}
		else if (e.number === -2147024882) quotaExceeded = true;
	}
	return quotaExceeded;
};
//#endregion


//# sourceMappingURL=isQuotaExceededError.mjs.map
// EXTERNAL MODULE: ../shared-fe/es/railsEnv.mjs
var railsEnv = __webpack_require__(36544);
;// CONCATENATED MODULE: ../shared-fe/es/segment.mjs

//#region src/segment.ts
var SEGMENT_METHODS = [
	"trackSubmit",
	"trackClick",
	"trackLink",
	"trackForm",
	"pageview",
	"identify",
	"reset",
	"group",
	"track",
	"ready",
	"alias",
	"debug",
	"page",
	"once",
	"off",
	"on",
	"addSourceMiddleware",
	"addIntegrationMiddleware",
	"setAnonymousId",
	"addDestinationMiddleware"
];
var RESET_PASSWORD_TOKEN_REGEX = /reset_password_token=[a-zA-Z0-9_\-\.]+?(?=&|$)/;
var ACCESS_TOKEN_REGEX = /access_token=[a-zA-Z0-9_\-\.]+?(?=&|$)/;
if (typeof window !== "undefined") {
	const segment = [];
	window.analytics = window.analytics || segment;
	segment.factory = function(method) {
		return function() {
			var args = Array.prototype.slice.call(arguments);
			args.unshift(method);
			segment.push(args);
			return segment;
		};
	};
	for (var i = 0; i < SEGMENT_METHODS.length; i++) {
		var key = SEGMENT_METHODS[i];
		segment[key] = segment.factory(key);
	}
	segment.addSourceMiddleware(({ payload, next }) => {
		if (navigator !== void 0 && navigator.userAgent && navigator.userAgent.includes !== void 0) {
			if (navigator.userAgent.includes("HeadlessChrome")) return null;
		}
		next(payload);
	});
	segment.SNIPPET_VERSION = "4.15.2";
	segment._loadOptions = { user: { localStorageFallbackDisabled: true } };
	segment.page({
		url: window.location.href.replace(RESET_PASSWORD_TOKEN_REGEX, "reset_password_token=REDACTED").replace(ACCESS_TOKEN_REGEX, "access_token=REDACTED"),
		search: window.location.search.replace(RESET_PASSWORD_TOKEN_REGEX, "reset_password_token=REDACTED").replace(ACCESS_TOKEN_REGEX, "access_token=REDACTED")
	});
}
var segment_segmentWrapper = {};
SEGMENT_METHODS.forEach((methodName) => {
	segment_segmentWrapper[methodName] = function() {
		window.analytics[methodName].apply(window.analytics, arguments);
	};
});
var loadSegment = (key) => {
	var script = document.createElement("script");
	script.type = "text/javascript";
	script.async = true;
	if (key) script.src = ("https:" === document.location.protocol ? "https://" : "http://") + "trkcdn.opendoor.com/analytics.js/v1/" + key + "/analytics.min.js";
	else script.src = ("https:" === document.location.protocol ? "https://" : "http://") + (getRailsEnv() === "production" ? "www.opendoor.com" : "demo.simplersell.com") + "/_scripts/sgm.min.js";
	var first = document.getElementsByTagName("script")[0];
	first.parentNode.insertBefore(script, first);
};
//#endregion


//# sourceMappingURL=segment.mjs.map
// EXTERNAL MODULE: ../../node_modules/.pnpm/@sentry+core@7.120.4/node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(94);
;// CONCATENATED MODULE: ../shared-fe/es/analytics.mjs





//#region src/analytics.ts
/**
* User-agent used by Invicti, the web scanner we use at OpenDoor to scan for security concerns
* We do not want to track events from Invicti in journey as they are not true UserEvents
* ip: 54.88.149.100
*/
var naivePattern = /bot|spider|crawl|http|lighthouse|.*Netsparker|.*ThousandEyes-Dragonfly-x1|X-Athena/i;
var isbotNaive = (userAgent) => Boolean(userAgent) && naivePattern.test(userAgent);
var LOG_LEVEL_CONFIG_NAME = "opendoor_log_level";
var log = (..._args) => {
	if (typeof window !== "undefined" && window.localStorage.getItem(LOG_LEVEL_CONFIG_NAME) === "true") console.log(..._args);
};
var wrapQuotaError = (cb) => {
	try {
		cb();
	} catch (e) {
		if (!isQuotaExceededError(e)) esm_exports/* captureException */.Tb(e);
	}
};
var register = (traits) => {
	if (typeof ga === "function" && typeof traits === "object") ga("set", traits);
	segment_segmentWrapper.identify(traits);
	if ((0,railsEnv/* getRailsEnv */.YE)() !== "production") log(`[DEBUG] Analytics.register: \n${JSON.stringify(traits, null, 2)}`);
};
var registerWithUserID = (userId, traits) => {
	if (typeof ga === "function" && typeof traits === "object") ga("set", traits);
	segmentWrapper.identify(userId, traits);
	if (getRailsEnv() !== "production") log(`[DEBUG] Analytics.register: \n${userId} ${JSON.stringify(traits, null, 2)}`);
};
var trackEvent = (category, action, value, extra) => {
	if (isbotNaive(navigator.userAgent)) return;
	wrapQuotaError(() => {
		if (typeof ga === "function") ga("send", "event", category, action, value, extra);
	});
	wrapQuotaError(() => {
		segment_segmentWrapper.track(`${category}-${action}`, {
			channel: "web",
			domain: window.location.host,
			screen: {
				height: window.screen.height,
				width: window.screen.width
			},
			value,
			...extra
		});
	});
	wrapQuotaError(() => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: `${category}.${action}.${value}`,
			extra
		});
	});
	if ((0,railsEnv/* getRailsEnv */.YE)() !== "production") log(`[DEBUG] Analytics.trackEvent: \n${category}-${action} ${JSON.stringify({
		value,
		...extra
	}, null, 2)}`);
};
var matchInAppQueryParam = (queryParams) => {
	const fragments = queryParams && queryParams.match(/app\=(\d+)/);
	if (!fragments) return false;
	return !!fragments[1];
};
var trackPageView = (extra) => {
	const history = createBrowserHistory();
	const pathname = history.location.pathname;
	const search = history.location.search;
	trackEvent("page", "view", "page", {
		app: matchInAppQueryParam(search),
		pathname,
		search,
		...extra
	});
};
//#endregion


//# sourceMappingURL=analytics.mjs.map
// EXTERNAL MODULE: ../shared-fe/es/store/session/selectors.mjs
var selectors = __webpack_require__(30405);
// EXTERNAL MODULE: ../../node_modules/.pnpm/redux-saga@0.15.3/node_modules/redux-saga/lib/effects.js
var effects = __webpack_require__(89308);
;// CONCATENATED MODULE: ../shared-fe/es/store/session/saga.mjs





//#region src/store/session/saga.ts
var SessionSaga = class {
	sessionApi;
	constructor(sessionApi) {
		this.sessionApi = sessionApi;
		Object.getOwnPropertyNames(Object.getPrototypeOf(this)).filter((key) => key !== "constructor").forEach((key) => {
			this[key] = this[key].bind(this);
		});
	}
	*maybeFetchSessionInfo() {
		if (!(yield (0,effects/* select */.Ys)(selectors/* infoIsLoaded */.Jv))) {
			yield (0,effects/* put */.gz)((0,actions/* beginLoadingSessionInfo */.fC)());
			yield this.fetchSessionInfo();
		}
	}
	*fetchSessionInfo() {
		try {
			const session = yield (0,effects/* call */.RE)(this.sessionApi.fetchSessionInfo);
			const human = session && session.human;
			register({ email: human && human.email });
			yield (0,effects/* put */.gz)((0,actions/* receiveSessionInfo */.zn)(session));
		} catch (e) {
			yield (0,effects/* put */.gz)((0,actions/* errorSessionInfo */.MI)(e.message));
		}
	}
	*logIn(action) {
		const { email, password, googleIDToken, facebookIDToken } = action.payload;
		try {
			yield (0,effects/* put */.gz)((0,actions/* beginLogIn */.tc)());
			const logInResponse = yield (0,effects/* call */.RE)(this.sessionApi.logIn, email, password, googleIDToken, facebookIDToken);
			if (logInResponse && logInResponse.error) {
				yield (0,effects/* put */.gz)((0,actions/* errorLogIn */.x5)(logInResponse.error));
				trackEvent("session", "login", "success-with-error", {
					email,
					error: logInResponse.error
				});
			} else {
				yield (0,effects/* put */.gz)((0,actions/* fetchSessionInfo */.TM)());
				yield (0,effects/* put */.gz)((0,actions/* successLogIn */.Js)(logInResponse.redirect_to));
			}
			trackEvent("session", "login", "success", { email });
		} catch (e) {
			const response = e.response;
			const errMessage = e.message;
			if (response && response.error) trackEvent("session", "login", "error-with-response", {
				email,
				error: errMessage
			});
			yield (0,effects/* put */.gz)((0,actions/* errorLogIn */.x5)(errMessage, response && response.status));
			trackEvent("session", "login", "error", {
				email,
				error: e.message || response && response.status
			});
		}
	}
	parseHumanStatus = (statusResponse) => {
		return {
			hasAutoGeneratedPassword: !!(statusResponse && statusResponse.has_generated_password),
			isNewHuman: statusResponse === null
		};
	};
	*maybeResetPassword(payload, trackEvent) {
		if (payload.shouldResetPassword) {
			yield (0,effects/* call */.RE)(this.sessionApi.requestResetPassword, payload.email);
			trackEvent("reset-password", payload);
		}
	}
	*requestPasswordReset(action) {
		const { email } = action.payload;
		const trackEvent$1 = (label, opt) => trackEvent("session", "reset-password", label, opt);
		try {
			yield (0,effects/* put */.gz)((0,actions/* beginRequestPasswordReset */._f)());
			const statusResponse = yield (0,effects/* call */.RE)(this.sessionApi.requestHumanStatus, email);
			const humanStatus = this.parseHumanStatus(statusResponse);
			const payload = {
				email,
				...humanStatus
			};
			const { hasAutoGeneratedPassword, isNewHuman } = humanStatus;
			yield (0,effects/* call */.RE)(this.maybeResetPassword, {
				...payload,
				shouldResetPassword: !isNewHuman
			}, trackEvent$1);
			yield (0,effects/* put */.gz)((0,actions/* successRequestPasswordReset */.Km)(email, hasAutoGeneratedPassword, isNewHuman));
			trackEvent$1(isNewHuman ? "no-account" : "success", payload);
		} catch (e) {
			const response = e.response;
			const error = e.message;
			if (response) {
				if (response && response.error) {
					yield (0,effects/* put */.gz)((0,actions/* errorRequestPasswordReset */.jb)(error, response.status));
					trackEvent$1("error", {
						email,
						error
					});
					return;
				}
			}
			yield (0,effects/* put */.gz)((0,actions/* successRequestPasswordReset */.Km)(email, false, true));
			trackEvent$1("no-account", { email });
			return;
		}
	}
	*requestHumanStatus(action) {
		const { email } = action.payload;
		const trackEvent$2 = (label, opt) => trackEvent("session", "request-human-status", label, opt);
		try {
			yield (0,effects/* put */.gz)((0,actions/* beginRequestHumanStatus */.i)());
			const statusResponse = yield (0,effects/* call */.RE)(this.sessionApi.requestHumanStatus, email);
			const humanStatus = this.parseHumanStatus(statusResponse);
			const payload = {
				email,
				...humanStatus
			};
			const { hasAutoGeneratedPassword, isNewHuman } = humanStatus;
			yield (0,effects/* put */.gz)((0,actions/* successRequestHumanStatus */.Jx)(email, hasAutoGeneratedPassword, isNewHuman));
			trackEvent$2(isNewHuman ? "no-account" : "success", payload);
		} catch (e) {
			const response = e.response;
			const error = e.message;
			if (response && response.error) {
				yield (0,effects/* put */.gz)((0,actions/* errorRequestHumanStatus */.P7)(error, response.status));
				trackEvent$2("error", {
					email,
					error
				});
				return;
			}
			yield (0,effects/* put */.gz)((0,actions/* successRequestHumanStatus */.Jx)(email, false, true));
			trackEvent$2("no-account", { email });
			return;
		}
	}
	*register(action) {
		const { email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl } = action.payload;
		try {
			yield (0,effects/* put */.gz)((0,actions/* beginRegister */.Kq)());
			const registerResponse = yield (0,effects/* call */.RE)(this.sessionApi.register, email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl);
			if (registerResponse && registerResponse.error) throw new Error(registerResponse.error);
			if (registerResponse && registerResponse.errors) {
				const errorField = Object.keys(registerResponse.errors)[0];
				const errorsArray = registerResponse.errors[errorField];
				if (Array.isArray(errorsArray)) throw Error(`That ${errorField.replace("primary_phone", "phone number").replace("_", " ")} ${errorsArray[0]}.`);
			}
			yield (0,effects/* put */.gz)((0,actions/* fetchSessionInfo */.TM)());
			yield (0,effects/* put */.gz)((0,actions/* successRegister */.V1)(registerResponse?.redirect_to));
			trackEvent("session", "register", "success", { email });
		} catch (e) {
			yield (0,effects/* put */.gz)((0,actions/* errorRegister */.T7)(e.message));
			trackEvent("session", "register", "error", {
				email,
				error: e.message
			});
		}
	}
	*maybeLogOut() {
		try {
			if (yield (0,effects/* select */.Ys)(selectors/* loggedIn */.Pl)) yield (0,effects/* call */.RE)(this.sessionApi.logOut);
			yield (0,effects/* put */.gz)((0,actions/* loggedOut */.k4)());
		} catch (e) {
			yield (0,effects/* put */.gz)((0,actions/* errorSessionInfo */.MI)(e.message));
		}
	}
	*saga() {
		yield (0,effects/* all */.$6)([
			(0,effects/* takeLatest */.Fm)(actionTypes/* MAYBE_FETCH_SESSION_INFO */.Vz, this.maybeFetchSessionInfo),
			(0,effects/* takeLatest */.Fm)(actionTypes/* FETCH_SESSION_INFO */.km, this.fetchSessionInfo),
			(0,effects/* takeLatest */.Fm)(actionTypes/* LOG_IN */.xr, this.logIn),
			(0,effects/* takeLatest */.Fm)(actionTypes/* REGISTER */.Nz, this.register),
			(0,effects/* takeLatest */.Fm)(actionTypes/* MAYBE_LOG_OUT */.ix, this.maybeLogOut),
			(0,effects/* takeLatest */.Fm)(actionTypes/* REQUEST_HUMAN_STATUS */.KL, this.requestHumanStatus),
			(0,effects/* takeLatest */.Fm)(actionTypes/* REQUEST_RESET_PASSWORD */.rd, this.requestPasswordReset)
		]);
	}
};
//#endregion


//# sourceMappingURL=saga.mjs.map
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-redux@5.0.5_react@18.3.1_redux@3.6.0/node_modules/react-redux/es/index.js + 11 modules
var es = __webpack_require__(37796);
// EXTERNAL MODULE: ../../node_modules/.pnpm/redux@3.6.0/node_modules/redux/es/index.js + 15 modules
var redux_es = __webpack_require__(50873);
// EXTERNAL MODULE: ../../node_modules/.pnpm/redux-immutable@4.0.0_immutable@4.0.0-rc.3/node_modules/redux-immutable/dist/index.js
var dist = __webpack_require__(54621);
// EXTERNAL MODULE: ../../node_modules/.pnpm/redux-saga@0.15.3/node_modules/redux-saga/es/index.js + 4 modules
var redux_saga_es = __webpack_require__(15751);
// EXTERNAL MODULE: ../../node_modules/.pnpm/redux-saga@0.15.3/node_modules/redux-saga/es/effects.js
var es_effects = __webpack_require__(3796);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(79758);
;// CONCATENATED MODULE: ./src/components/shared/ReduxWrapper.tsx













var sagas = function sagas() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,es_effects/* all */.$6)([
                        (0,es_effects/* fork */.rM)(new SessionSaga(new SessionApi(globals/* XSRF_COOKIE_KEY */.x0, globals/* RAILS_URL */.oF)).saga)
                    ])
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
};
var sagaMiddleware = (0,redux_saga_es/* default */.ZP)({
    onError: sagaMiddlewareErrorHandler
});
var composeEnhancers = ( true && window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_es/* compose */.qC;
var reducers = {
    session: session_default.reducer
};
var store = (0,redux_es/* createStore */.MT)((0,dist/* combineReducers */.U)((0,_object_spread/* default */.Z)({}, reducers)), undefined, composeEnhancers((0,redux_es/* applyMiddleware */.md)(sagaMiddleware)));
sagaMiddleware.run(sagas);
var ReduxWrapper = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(es/* Provider */.zt, {
        store: store,
        children: props.children
    });
};
/* harmony default export */ var shared_ReduxWrapper = (ReduxWrapper);


/***/ }),

/***/ 50852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ GoogleAuthRedirectButton; }
});

// UNUSED EXPORTS: sanitizeRedirectPath

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(88149);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe11.esm.js
//#region src/google/authError.ts
var AUTH_ERROR_QUERY_PARAM = "auth_error";
var AUTH_ERROR_CODES = [
    "missing_email",
    "provider_error",
    "record_not_found",
    "missing_strategy",
    "reauth_requires_login",
    "identity_mismatch",
    "unknown"
];
var MESSAGES = {
    missing_email: "We couldn't get an email from your Google account. Try again or sign in with email.",
    provider_error: "This email is already linked to a different sign-in method. Please use your original sign-in method.",
    record_not_found: "We couldn't find or create your account. Please try again or contact support.",
    missing_strategy: "Sign-in isn't available right now. Please try again in a moment.",
    reauth_requires_login: "Your session has expired. Please sign in again to continue.",
    identity_mismatch: "That Google account doesn't match the one you're signed in as. Please choose the matching account.",
    unknown: "Something went wrong signing you in. Please try again."
};
var normalizeAuthErrorCode = function(raw) {
    if (raw && AUTH_ERROR_CODES.includes(raw)) return raw;
    return "unknown";
};
var getAuthErrorMessage = function(raw) {
    return MESSAGES[normalizeAuthErrorCode(raw)];
};
var readRawAuthErrorFromLocation = function() {
    if (false) {}
    var raw = new URLSearchParams(window.location.search).get(AUTH_ERROR_QUERY_PARAM);
    return raw && raw.length > 0 ? raw : null;
};
/**
* Removes `auth_error` from the current URL while preserving every other query
* param, the pathname, and the hash. Uses replaceState so the entry stays in
* history (no router event, no back/forward weirdness). No-op if the param is
* already absent or when running outside a browser.
*/ var stripAuthErrorFromUrl = function() {
    if (false) {}
    var url = new URL(window.location.href);
    if (!url.searchParams.has("auth_error")) return;
    url.searchParams.delete(AUTH_ERROR_QUERY_PARAM);
    var search = url.searchParams.toString();
    var newUrl = url.pathname + (search ? "?".concat(search) : "") + (url.hash || "");
    window.history.replaceState({}, "", newUrl);
};
//#endregion


// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(5108);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25313);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/forms/google/GoogleIcon.js
var GoogleIcon = __webpack_require__(77391);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(349);
// EXTERNAL MODULE: ../observability/dist/chunks/chunk-VIS2X3AA.mjs + 1 modules
var chunk_VIS2X3AA = __webpack_require__(34654);
;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe12.esm.js








//#region src/google/GoogleAuthRedirectButton.tsx
var GOOGLE_AUTH_METHOD = 3;
var WEB_AUTH_SOURCE = 0;
var WEB_PLATFORM = 1;
/**
* Redirect-based Google auth button for the server-side OAuth flow.
* Navigates to /auth/google — Rails handles the full OAuth exchange via OmniAuth.
* No Google JavaScript SDK in the login path.
*/ var GoogleAuthRedirectButton = function(param) {
    var analyticsPrefix = param.analyticsPrefix, redirectTo = param.redirectTo, redirectIntent = param.redirectIntent, _label = param.label, label = _label === void 0 ? "Continue with Google" : _label, _size = param.size, size = _size === void 0 ? "medium" : _size, _variant = param.variant, variant = _variant === void 0 ? "secondary" : _variant, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, onBeforeNavigate = param.onBeforeNavigate, onBeforeNavigateError = param.onBeforeNavigateError;
    var handlePress = useGoogleRedirectHandler({
        redirectTo: redirectTo,
        redirectIntent: redirectIntent,
        onBeforeNavigate: onBeforeNavigate,
        onBeforeNavigateError: onBeforeNavigateError
    });
    var authErrorCode = useAuthErrorOnMount();
    var iconSize = size === "xsmall" || size === "small" ? 20 : 24;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%",
        maxWidth: fullWidth ? void 0 : 400
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        position: "relative"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, (0,_object_spread/* default */.Z)({
        analyticsName: "".concat(analyticsPrefix, "-google-redirect-button"),
        testID: "google-auth-redirect-button",
        label: label,
        size: size,
        variant: variant,
        onPress: handlePress
    }, fullWidth ? {
        width: "100%"
    } : {})), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        position: "absolute",
        left: "$12x",
        top: "50%",
        style: {
            transform: [
                {
                    translateY: "-50%"
                }
            ]
        },
        pointerEvents: "none"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GoogleIcon/* GoogleIcon */._, {
        size: iconSize
    }))), authErrorCode ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        paddingTop: "$4x",
        role: "alert",
        "aria-live": "polite",
        testID: "google-auth-error-message"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateErrorDefault"
    }, getAuthErrorMessage(authErrorCode))) : null);
};
/** Returns the path if it's a safe relative path, or undefined if it's absolute/protocol-relative/scheme-based. */ function sanitizeRedirectPath(path) {
    if (!path) return void 0;
    if (/^\/(?!\/)/.test(path)) return path;
    console.error("[GoogleAuthRedirectButton] rejected non-relative redirect path: ".concat(path));
}
function navigateToGoogleAuth(redirectTo, redirectIntent) {
    var url = new URL("/auth/google", window.location.origin);
    var currentParams = new URLSearchParams(window.location.search);
    var redirectFromParams = currentParams.get("redirect_to");
    currentParams.delete("redirect_to");
    currentParams.forEach(function(value, key) {
        url.searchParams.set(key, value);
    });
    var preservedSearch = currentParams.toString();
    var reauthDefaultRedirect = redirectIntent === "reauth" ? "".concat(window.location.pathname).concat(preservedSearch ? "?".concat(preservedSearch) : "") : void 0;
    var ref, ref1;
    var safeRedirect = redirectIntent === "reauth" ? (ref = sanitizeRedirectPath(redirectTo)) !== null && ref !== void 0 ? ref : sanitizeRedirectPath(reauthDefaultRedirect) : (ref1 = sanitizeRedirectPath(redirectTo)) !== null && ref1 !== void 0 ? ref1 : sanitizeRedirectPath(redirectFromParams);
    if (safeRedirect) url.searchParams.set("redirect_to", safeRedirect);
    if (redirectIntent) url.searchParams.set("redirect_intent", redirectIntent);
    window.location.href = url.pathname + url.search;
}
function trackGoogleRedirectInitiated() {
    chunk_VIS2X3AA/* globalObservability.trackJourneyEvent */.w.trackJourneyEvent("authentication", "redirectInitiated", {
        authMethod: GOOGLE_AUTH_METHOD,
        authSource: WEB_AUTH_SOURCE,
        platform: WEB_PLATFORM
    }, void 0, {
        flush: true
    });
}
function reportRedirectInitiatedTrackingError(error) {
    try {
        chunk_VIS2X3AA/* globalObservability.trackError */.w.trackError("google-auth-redirect-initiated-journey-event-failed", (0,_instanceof/* default */.Z)(error, Error) ? error : new Error(String(error)));
    } catch (e) {}
}
function useGoogleRedirectHandler(param) {
    var redirectTo = param.redirectTo, redirectIntent = param.redirectIntent, onBeforeNavigate = param.onBeforeNavigate, onBeforeNavigateError = param.onBeforeNavigateError;
    return (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _obj, ref, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    try {
                        trackGoogleRedirectInitiated();
                    } catch (e1) {
                        reportRedirectInitiatedTrackingError(e1);
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        onBeforeNavigate === null || onBeforeNavigate === void 0 ? void 0 : onBeforeNavigate()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        4,
                        onBeforeNavigateError === null || onBeforeNavigateError === void 0 ? void 0 : onBeforeNavigateError(e)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    (ref = (_obj = chunk_VIS2X3AA/* globalObservability.getJourneyEventClient */.w.getJourneyEventClient()).send) === null || ref === void 0 ? void 0 : ref.call(_obj);
                    navigateToGoogleAuth(redirectTo, redirectIntent);
                    return [
                        2
                    ];
            }
        });
    }), [
        redirectTo,
        redirectIntent,
        onBeforeNavigate,
        onBeforeNavigateError
    ]);
}
/**
* Reads `?auth_error=` once on mount, fires telemetry, strips the param. Returns
* the normalized code for inline rendering, or null when no error is present.
*/ function useAuthErrorOnMount() {
    var ref = (0,react.useState)(null), code = ref[0], setCode = ref[1];
    (0,react.useEffect)(function() {
        var raw = readRawAuthErrorFromLocation();
        if (raw === null) return;
        var normalized = normalizeAuthErrorCode(raw);
        setCode(normalized);
        stripAuthErrorFromUrl();
        reportAuthErrorDisplayed(normalized, raw);
    }, []);
    return code;
}
var AUTH_ERROR_DISPLAYED_MESSAGE = "Google OAuth redirect error displayed";
var SAFE_RAW_AUTH_ERROR_PATTERN = /^[a-z0-9_-]{1,64}$/;
function reportAuthErrorDisplayed(normalized, raw) {
    try {
        var data = {
            authMethod: GOOGLE_AUTH_METHOD,
            platform: WEB_PLATFORM,
            oauthErrorCode: normalized
        };
        if (raw !== normalized) {
            var trimmedRaw = raw.trim().toLowerCase();
            if (SAFE_RAW_AUTH_ERROR_PATTERN.test(trimmedRaw)) data.oauthErrorRawCode = trimmedRaw;
        }
        chunk_VIS2X3AA/* globalObservability.trackError */.w.trackError("google-auth-redirect-error-displayed", new Error(AUTH_ERROR_DISPLAYED_MESSAGE), {
            data: data
        });
    } catch (e) {}
}
//#endregion



/***/ }),

/***/ 98960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ auth_fe25_esm_AccountForm; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe13.esm.js



//#region src/flags/FeatureFlagGate.tsx
var FeatureFlagGate = function(param) {
    var flag = param.flag, evaluate = param.evaluate, enabledComponent = param.enabled, disabledComponent = param.disabled, loadingComponent = param.loading, _forceDisabled = param.forceDisabled, forceDisabled = _forceDisabled === void 0 ? false : _forceDisabled;
    if (forceDisabled) return disabledComponent;
    var ref = evaluate(flag), enabled = ref.enabled, loading = ref.loading;
    if (loading) return loadingComponent !== null && loadingComponent !== void 0 ? loadingComponent : disabledComponent;
    return enabled ? enabledComponent : disabledComponent;
};
var useAsyncFlag = function(flag, evaluate, skip) {
    var ref = (0,react.useState)({
        enabled: false,
        loading: !skip
    }), state = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        if (skip) {
            setState({
                enabled: false,
                loading: false
            });
            return;
        }
        var stale = false;
        setState({
            enabled: false,
            loading: true
        });
        (0,_async_to_generator/* default */.Z)(function() {
            var enabled, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            evaluate(flag)
                        ];
                    case 1:
                        enabled = _state.sent();
                        if (stale) return [
                            2
                        ];
                        setState({
                            enabled: enabled,
                            loading: false
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if (stale) return [
                            2
                        ];
                        setState({
                            enabled: false,
                            loading: false
                        });
                        console.error("AsyncFeatureFlagGate: evaluator threw for flag", flag, error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            stale = true;
        };
    }, [
        evaluate,
        flag,
        skip
    ]);
    return state;
};
var AsyncFeatureFlagGate = function(param) {
    var flag = param.flag, evaluate = param.evaluate, enabledComponent = param.enabled, disabledComponent = param.disabled, loadingComponent = param.loading, _forceDisabled = param.forceDisabled, forceDisabled = _forceDisabled === void 0 ? false : _forceDisabled;
    var ref = useAsyncFlag(flag, evaluate, forceDisabled), enabled = ref.enabled, loading = ref.loading;
    if (forceDisabled) return disabledComponent;
    if (loading) return loadingComponent !== null && loadingComponent !== void 0 ? loadingComponent : disabledComponent;
    return enabled ? enabledComponent : disabledComponent;
};
//#endregion


// EXTERNAL MODULE: ../auth-fe/dist/auth-fe12.esm.js + 1 modules
var auth_fe12_esm = __webpack_require__(50852);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(47427);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(349);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(5108);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+styled@11.11.0_@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1__@types+react@18.3.28_react@18.3.1/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(89631);
;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe15.esm.js






//#region src/AccountForm/AccountFormCinderblocks/shared.tsx
/**
* Versioned marketing SMS consent language registry.
*
* All surfaces that display marketing SMS consent copy should import
* MARKETING_SMS_CONSENT from here.
*/ var CONSENT_VERSIONS = {
    marketing_sms_v1: {
        checkboxLabel: "I consent to receive marketing calls and texts from Opendoor and its affiliates to the number provided. I understand that I may opt out at any time and consent is not a condition of purchase.",
        ctaAgreement: function(ctaText) {
            return "By pressing “".concat(ctaText, ",” I agree to Opendoor’s Terms of Service and Privacy Policy.");
        },
        full: function(ctaText) {
            return "I consent to receive marketing calls and texts from Opendoor and its affiliates to the number provided. I understand that I may opt out at any time and consent is not a condition of purchase. By pressing “".concat(ctaText, ",” I agree to Opendoor’s Terms of Service and Privacy Policy.");
        },
        CtaAgreementLinked: function(param) {
            var ctaText = param.ctaText, tosAnalyticsName = param.tosAnalyticsName, privacyAnalyticsName = param.privacyAnalyticsName, _tosUrl = param.tosUrl, tosUrl = _tosUrl === void 0 ? "https://www.opendoor.com/w/terms" : _tosUrl, _privacyUrl = param.privacyUrl, privacyUrl = _privacyUrl === void 0 ? "https://www.opendoor.com/w/privacy" : _privacyUrl, _linkProps = param.linkProps, linkProps = _linkProps === void 0 ? {} : _linkProps;
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, "By pressing “", ctaText, ",” I agree to Opendoor’s", " ", /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, (0,_object_spread/* default */.Z)({
                analyticsName: tosAnalyticsName,
                href: tosUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Opens a new page with Opendoor’s terms of service",
                onPress: function() {}
            }, linkProps), "Terms of Service"), " ", "and", " ", /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, (0,_object_spread/* default */.Z)({
                analyticsName: privacyAnalyticsName,
                href: privacyUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Opens a new page with Opendoor’s privacy policy",
                onPress: function() {}
            }, linkProps), "Privacy Policy"), ".");
        }
    }
};
var CURRENT_VERSION = "marketing_sms_v1";
var MARKETING_SMS_CONSENT = (0,_object_spread/* default */.Z)({
    version: CURRENT_VERSION
}, CONSENT_VERSIONS[CURRENT_VERSION]);
var EmailDisclaimerText = function(param) {
    var analyticsName = param.analyticsName;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "p",
        typography: "$bodyXsmall",
        whiteSpace: "normal",
        $largerThanSM: {
            whiteSpace: "nowrap"
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(MARKETING_SMS_CONSENT.CtaAgreementLinked, {
        ctaText: "Continue",
        tosAnalyticsName: "".concat(analyticsName, "-terms"),
        privacyAnalyticsName: "".concat(analyticsName, "-privacy-policy"),
        linkProps: {
            variant: "primary",
            size: "xsmall"
        }
    }));
};
var AccountFormHeader = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        tag: "h1",
        typography: "$headerMedium"
    }, rest), {
        marginBottom: "$10x",
        textAlign: "left"
    }), children);
};
var AccountFormWrapper = function(props) {
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, (0,_object_spread/* default */.Z)({
        width: "100%"
    }, props));
};
var FormWrapper = function(props) {
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, (0,_object_spread/* default */.Z)({
        width: "100%",
        flexDirection: "column"
    }, props));
};
var Form$1 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("form", {
    target: "etcoizl0"
})("width:100%;margin-top:28px;/* $7x token equivalent */");
var Disclaimer = function(_param) {
    var children = _param.children, _desktopNoWrap = _param.desktopNoWrap, desktopNoWrap = _desktopNoWrap === void 0 ? false : _desktopNoWrap, shouldRenderDisclaimerAboveCTA = _param.shouldRenderDisclaimerAboveCTA, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "desktopNoWrap",
        "shouldRenderDisclaimerAboveCTA"
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, props, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "p",
        typography: "$bodyXsmall",
        color: "$contentSecondary",
        whiteSpace: "normal",
        $largerThanSM: desktopNoWrap ? {
            whiteSpace: "nowrap"
        } : void 0
    }, children));
};
//#endregion


// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/forms/EmailInput.js
var EmailInput = __webpack_require__(7181);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/forms/AccountFormControls.js
var AccountFormControls = __webpack_require__(38254);
;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe16.esm.js



//#region src/AccountForm/AccountFormCinderblocks/AccountEmailForm.tsx
var AccountEmailForm = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var _showForgotPassword = param.showForgotPassword, showForgotPassword = _showForgotPassword === void 0 ? true : _showForgotPassword, analyticsName = param.analyticsName, loading = param.loading, openForgotPasswordInNewTab = param.openForgotPasswordInNewTab, onSubmit = param.onSubmit, tmp = param.email, initialEmail = tmp === void 0 ? "" : tmp;
    var _$ref = (0,react.useState)(initialEmail), prefillEmail = _$ref[0], setPrefillEmail = _$ref[1];
    var _$ref1 = (0,react.useState)(initialEmail), email = _$ref1[0], setEmail = _$ref1[1];
    var _$ref2 = (0,react.useState)(false), hasError = _$ref2[0], setHasError = _$ref2[1];
    var maybePrefillEmail = function() {
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.searchParams);
        if (params.get("email")) setPrefillEmail(params.get("email") || initialEmail);
    };
    (0,react.useEffect)(function() {
        maybePrefillEmail();
    }, []);
    var handleSubmit = function(e) {
        e.preventDefault();
        if (!hasError) onSubmit(email);
        if (ref && "current" in ref && ref.current) ref.current.focus();
    };
    var handleValidityChange = function(validity) {
        setHasError(validity !== "valid");
        if (validity !== "valid" && ref && "current" in ref && ref.current) ref.current.focus();
    };
    var isDisabled = hasError || !email;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Form$1, {
        onSubmitCapture: handleSubmit
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$4x"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(EmailInput/* EmailInput */.U, {
        ref: ref,
        analyticsName: analyticsName,
        title: "Email",
        getValue: function(value) {
            return setEmail(value.unformattedValue == null ? "" : value.unformattedValue);
        },
        onValidationChange: handleValidityChange,
        prefilledValue: prefillEmail,
        fieldRequiredError: "This field is required",
        invalidEmailError: "Please enter a valid email address",
        size: "medium"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountFormControls/* AccountFormControls */.W, {
        actionText: "Continue with email",
        analyticsName: analyticsName,
        loading: loading,
        disabled: isDisabled,
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        submitA11yProps: {
            "aria-label": ""
        },
        showForgotPassword: showForgotPassword,
        forgotPasswordText: "Forgot your password?",
        forgotPasswordAriaNewWindow: "Opens a new window with the forgot password page",
        forgotPasswordAriaSameWindow: "Opens the forgot password page"
    })));
});
AccountEmailForm.displayName = "AccountEmailForm";
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe17.esm.js


//#region src/AccountForm/AccountFormCinderblocks/AccountFormSubHeader.tsx
var AccountFormSubHeader = function(param) {
    var loginSubHeaderText = param.loginSubHeaderText, registrationSubHeaderText = param.registrationSubHeaderText, email = param.email, onValidEmailReset = param.onValidEmailReset, hasSubmittedEmail = param.hasSubmittedEmail, isNewHuman = param.isNewHuman, hidePasswordField = param.hidePasswordField, phoneNumberInputHidden = param.phoneNumberInputHidden;
    var actionText = isNewHuman ? "Signing up" : "Signing in";
    var subHeaderText = isNewHuman ? registrationSubHeaderText : loginSubHeaderText;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, null, subHeaderText && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$subheaderSmall",
        marginTop: "$5x",
        marginBottom: "$5x",
        tag: "h2"
    }, subHeaderText), hasSubmittedEmail && !hidePasswordField && !phoneNumberInputHidden && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$bodySmall",
        tag: "p",
        gap: "$2x"
    }, actionText, " as", " ", /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: "#",
        size: "small",
        variant: "secondary",
        analyticsName: "Reset email",
        onPress: onValidEmailReset
    }, email)));
};
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe18.esm.js

//#region src/AccountForm/AccountFormCinderblocks/NamelessAccountContext.tsx
var NamelessAccountContext = /*#__PURE__*/ react.createContext({
    shouldRegisterOnEmailSubmit: false,
    onPasswordFormLoad: void 0,
    onAccountUpdate: void 0,
    emailRegistrationError: ""
});
var NamelessAccountContextProvider = function(param) {
    var shouldRegisterOnEmailSubmit = param.shouldRegisterOnEmailSubmit, onPasswordFormLoad = param.onPasswordFormLoad, onAccountUpdate = param.onAccountUpdate, emailRegistrationError = param.emailRegistrationError, children = param.children;
    return /* @__PURE__ */ /*#__PURE__*/ React.createElement(NamelessAccountContext.Provider, {
        value: {
            shouldRegisterOnEmailSubmit: shouldRegisterOnEmailSubmit,
            onPasswordFormLoad: onPasswordFormLoad,
            onAccountUpdate: onAccountUpdate,
            emailRegistrationError: emailRegistrationError
        }
    }, children);
};
//#endregion


// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/forms/NameInput.js
var NameInput = __webpack_require__(1602);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/forms/AccountPasswordInput.js
var AccountPasswordInput = __webpack_require__(82515);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/forms/PhoneInput.js
var PhoneInput = __webpack_require__(91965);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/checkboxRadio/SimpleCheckbox.js
var SimpleCheckbox = __webpack_require__(52987);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25313);
;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe19.esm.js




//#region src/AccountForm/AccountFormCinderblocks/AccountPasswordForm.tsx
var AccountPasswordForm = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var initialName = param.name, initialPhone = param.phone, onRegister = param.onRegister, onLogin = param.onLogin, hidePasswordField = param.hidePasswordField, isNewHuman = param.isNewHuman, onboardingAccountPageCTA = param.onboardingAccountPageCTA, passwordFormActionText = param.passwordFormActionText, analyticsName = param.analyticsName, fullNameLabel = param.fullNameLabel, fullNamePlaceholder = param.fullNamePlaceholder, loading = param.loading, loginError = param.loginError, _phoneNumberInputOptional = param.phoneNumberInputOptional, phoneNumberInputOptional = _phoneNumberInputOptional === void 0 ? true : _phoneNumberInputOptional, _phoneNumberInputHidden = param.phoneNumberInputHidden, phoneNumberInputHidden = _phoneNumberInputHidden === void 0 ? false : _phoneNumberInputHidden, showPasswordlessLogin = param.showPasswordlessLogin, onRequestPasswordlessLogin = param.onRequestPasswordlessLogin, isRequestingPasswordlessLogin = param.isRequestingPasswordlessLogin, openForgotPasswordInNewTab = param.openForgotPasswordInNewTab, fullNameOptional = param.fullNameOptional, fullNameHidden = param.fullNameHidden;
    var context = (0,react.useContext)(NamelessAccountContext);
    var _$ref = (0,react.useState)(false), hasError = _$ref[0], setHasError = _$ref[1];
    var _$ref1 = (0,react.useState)(initialName || ""), name = _$ref1[0], setName = _$ref1[1];
    var _$ref2 = (0,react.useState)(false), hasNameError = _$ref2[0], setNameError = _$ref2[1];
    var _$ref3 = (0,react.useState)(false), hasPasswordError = _$ref3[0], setHasPasswordError = _$ref3[1];
    var _$ref4 = (0,react.useState)(initialPhone || ""), phone = _$ref4[0], setPhone = _$ref4[1];
    var _$ref5 = (0,react.useState)(false), smsSubscribed = _$ref5[0], setSmsSubscribed = _$ref5[1];
    var _$ref6 = (0,react.useState)(!phoneNumberInputOptional), hasPhoneError = _$ref6[0], setPhoneError = _$ref6[1];
    var _$ref7 = (0,react.useState)(""), password = _$ref7[0], setPassword = _$ref7[1];
    var _$ref8 = (0,react.useState)({}), lastSubmit = _$ref8[0], setLastSubmit = _$ref8[1];
    var getPhoneState = (0,react.useCallback)(function(phone) {
        if (phone == null || phone === "") return {
            hasError: !phoneNumberInputOptional,
            value: phone
        };
        return {
            hasError: false,
            value: phone
        };
    }, [
        phoneNumberInputOptional
    ]);
    var maybePrefillAccount = (0,react.useCallback)(function() {
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.searchParams);
        var _$ref = getPhoneState(params.get("phoneNumber") || initialPhone), value = _$ref.value, hasError = _$ref.hasError;
        if (params.get("name") || params.get("phoneNumber")) {
            var _$ref1;
            setName((_$ref1 = params.get("name")) !== null && _$ref1 !== void 0 ? _$ref1 : "");
            setPhone(hasError ? "" : value !== null && value !== void 0 ? value : "");
            setPhoneError(hasError);
        }
    }, [
        getPhoneState,
        initialPhone
    ]);
    (0,react.useEffect)(function() {
        maybePrefillAccount();
        if (context.onPasswordFormLoad) context.onPasswordFormLoad();
    }, [
        context,
        maybePrefillAccount
    ]);
    var validatePasswordLength = function(password) {
        return password.length >= 5 && password.length <= 128;
    };
    var onNameChange = function(name) {
        setName(name);
        var isNameEmpty = name == null || name === "";
        var isNameValid = name.trim() !== "";
        if (fullNameOptional) setNameError(isNameEmpty ? false : !isNameValid);
        else setNameError(isNameEmpty || !isNameValid);
    };
    var handlePhoneValidationChange = function(validity) {
        setPhoneError(validity !== "valid");
    };
    var onPasswordChange = function(password) {
        setHasPasswordError(false);
        setHasError(password == null || !validatePasswordLength(password));
        setPassword(password);
    };
    var handleSubmit = function(e) {
        e.preventDefault();
        if (hasError || isNewHuman && (hasNameError || hasPhoneError)) return;
        if (Object.values(lastSubmit).filter(Boolean).length !== 0 && name === lastSubmit.name && password === lastSubmit.password && phone === lastSubmit.phone) return;
        if (isNewHuman) if (context.shouldRegisterOnEmailSubmit && context.onAccountUpdate) context.onAccountUpdate(name, phone, smsSubscribed);
        else onRegister(password, name, phone);
        else onLogin(password);
        setLastSubmit({
            name: name,
            password: password,
            phone: phone
        });
    };
    var shouldDisableSubmit = hasError || !hidePasswordField && (!password || password.length === 0) || isNewHuman && (!fullNameOptional && (!name || hasNameError) || hasPhoneError);
    var actionText = "Confirm";
    if (phoneNumberInputHidden) actionText = "Next";
    else if (onboardingAccountPageCTA) actionText = "Continue";
    if (passwordFormActionText) actionText = passwordFormActionText;
    var showPasswordError = hasPasswordError && isNewHuman || loginError, passwordErrorText = loginError ? loginError : "Your password does not meet the requirements";
    var shouldRenderDisclaimerAboveCTA = !phoneNumberInputHidden && isNewHuman;
    var shouldRenderDisclaimerBelowCTA = !shouldRenderDisclaimerAboveCTA;
    (0,react.useEffect)(function() {
        if (showPasswordError && passwordErrorText) {
            if (ref && "current" in ref && ref.current) ref.current.focus();
        }
    }, [
        showPasswordError,
        passwordErrorText
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Form$1, {
        onSubmitCapture: handleSubmit
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        marginBottom: "$20x"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$20x"
    }, isNewHuman && !fullNameHidden && /* @__PURE__ */ /*#__PURE__*/ react.createElement(NameInput/* NameInput */.R, {
        analyticsName: analyticsName,
        autoComplete: "name",
        autoFocus: true,
        errorText: hasNameError ? "Please enter your full name." : void 0,
        title: fullNameLabel ? fullNameLabel : "Full name",
        onChangeText: onNameChange,
        placeholder: fullNamePlaceholder ? fullNamePlaceholder : "",
        required: !fullNameOptional,
        prefilledValue: name,
        invalidNameError: "Please enter your full name.",
        size: "medium"
    }), !hidePasswordField && /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountPasswordInput/* AccountPasswordInput */.j, {
        analyticsName: analyticsName,
        autoFocus: !isNewHuman,
        supportText: "Your password must be 6 to 128 characters long",
        errorText: showPasswordError && passwordErrorText,
        onBlur: function() {
            setHasPasswordError(password.length > 0 && !validatePasswordLength(password));
        },
        title: "Password",
        ref: ref,
        onChangeText: onPasswordChange,
        prefilledValue: password,
        size: "medium"
    }), isNewHuman && !phoneNumberInputHidden && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$5x"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(PhoneInput/* PhoneInput */.s, {
        analyticsName: analyticsName,
        title: "Phone number",
        onChangeText: function(value) {
            return setPhone(value);
        },
        onValidationChange: handlePhoneValidationChange,
        required: !phoneNumberInputOptional,
        prefilledValue: phone,
        invalidPhoneError: "Please enter a valid phone number",
        fieldRequiredError: "This field is required",
        size: "medium"
    }), analyticsName === "reception-fe-account-form" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(SimpleCheckbox/* SimpleCheckbox */.A, {
        size: "xsmall",
        label: MARKETING_SMS_CONSENT.checkboxLabel,
        value: "value",
        analyticsName: "".concat(analyticsName, "-sms-checkbox"),
        onPress: function(_, checked) {
            if (typeof checked === "boolean") setSmsSubscribed(checked);
        },
        name: "marketing-opt-in"
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        mt: shouldRenderDisclaimerAboveCTA ? "$0x" : "$4x",
        $largerThanSM: {
            marginBottom: shouldRenderDisclaimerAboveCTA ? "$10x" : null
        },
        $smallerThanMD: {
            marginBottom: shouldRenderDisclaimerAboveCTA ? "$5x" : null
        }
    }, shouldRenderDisclaimerAboveCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(EmailDisclaimerText, {
        analyticsName: analyticsName
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountFormControls/* AccountFormControls */.W, {
        actionText: actionText,
        analyticsName: analyticsName,
        loading: loading,
        showForgotPassword: !isNewHuman,
        onRequestPasswordlessLogin: onRequestPasswordlessLogin,
        isRequestingPasswordlessLogin: isRequestingPasswordlessLogin,
        disabled: shouldDisableSubmit,
        submitA11yProps: {
            "aria-label": ""
        },
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        forgotPasswordText: "Forgot your password?",
        forgotPasswordAriaNewWindow: "Opens a new window with the forgot password page",
        forgotPasswordAriaSameWindow: "Opens the forgot password page"
    }))), showPasswordlessLogin && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        "data-testid": "passwordless-login",
        paddingTop: "$20x",
        marginBottom: "$20x",
        borderTopWidth: 1,
        borderTopColor: "$borderPrimary"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$subheaderSmall",
        tag: "h3",
        paddingBottom: "$10x",
        textAlign: "left"
    }, "Tired of resetting your password?"), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$bodySmall",
        tag: "h3",
        textAlign: "left",
        paddingBottom: "$20x"
    }, "We can email you a link that will simply log you into your account."), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        variant: "secondary",
        loading: isRequestingPasswordlessLogin,
        analyticsName: "".concat(analyticsName, "-email-login-link"),
        "aria-label": null,
        onPress: onRequestPasswordlessLogin,
        size: "medium",
        label: "Email login link"
    })), shouldRenderDisclaimerBelowCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Disclaimer, {
        mt: 5
    }, "Your information is protected by our\xa0", /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: "https://www.opendoor.com/w/privacy",
        target: "_blank",
        analyticsName: "".concat(analyticsName, "-privacy-policy"),
        "aria-label": "Opens a new page with Opendoor’s privacy policy",
        typography: "$bodyXsmall",
        onPress: function() {}
    }, "Privacy Policy"), ".", /* @__PURE__ */ /*#__PURE__*/ react.createElement("br", null), /* @__PURE__ */ /*#__PURE__*/ react.createElement("br", null)));
});
AccountPasswordForm.displayName = "AccountPasswordForm";
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe20.esm.js


//#region src/AccountForm/AccountFormCinderblocks/CheckEmailForm.tsx
var CheckEmailForm = function(param) {
    var hasGeneratedPassword = param.hasGeneratedPassword, email = param.email, analyticsName = param.analyticsName, onResetValidEmail = param.onResetValidEmail, requestResetPassword = param.requestResetPassword;
    var headerText = hasGeneratedPassword ? "Set up your account" : "Check your email", emailInstructionText = hasGeneratedPassword ? "First, check your email and click the link to set up your password. We emailed a link to ".concat(email, ".") : "We’ve sent reset password instructions to ".concat(email, ". Once you’ve reset your password, sign in again.");
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$20x"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$10x"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "h2",
        typography: "$headerMedium"
    }, headerText), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "p",
        typography: "$bodySmall"
    }, emailInstructionText)), hasGeneratedPassword ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, requestResetPassword && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        variant: "primary",
        size: "small",
        label: "Resend email",
        onPress: function() {
            return requestResetPassword(email);
        },
        analyticsName: "".concat(analyticsName, "-resend-reset-password-email"),
        "aria-label": "Resend email"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "p",
        typography: "$bodyMedium"
    }, "We’ve sent reset password instructions to ", email, ". Once you’ve reset your password,", " ", /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        variant: "primary",
        href: "/login",
        size: "medium",
        onPress: onResetValidEmail,
        analyticsName: "".concat(analyticsName, "-sign-in-after-reset-password"),
        "aria-label": "Sign In",
        "data-testid": "sign-in-after-reset-password"
    }, "sign in again"))) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        variant: "primary",
        size: "small",
        label: "Sign In",
        onPress: onResetValidEmail,
        analyticsName: "".concat(analyticsName, "-sign-in-after-reset-password"),
        "aria-label": "Sign In",
        "data-testid": "sign-in-after-reset-password"
    }));
};
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe21.esm.js


//#region src/AccountForm/AccountFormCinderblocks/ErrorPrompt.tsx
/**
* Custom ErrorPrompt component to replace legacy Bricks ErrorPrompt
*/ var ErrorPrompt = function(param) {
    var message = param.message;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        "data-testid": "error-prompt",
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateErrorDefault",
        marginTop: "$1dot5x"
    }, message);
};
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe22.esm.js


//#region src/AccountForm/AccountFormCinderblocks/PasswordlessResultPage.tsx
var PasswordlessResultPage = function(param) {
    var email = param.email, hasSucceeded = param.hasSucceeded, analyticsName = param.analyticsName;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%",
        py: "$36x",
        px: "$12x",
        gap: "$10x",
        $largerThanSM: {
            width: 480
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "h1",
        typography: "$headerMedium"
    }, hasSucceeded ? "Check your email" : "Something went wrong."), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "p",
        typography: "$bodySmall"
    }, hasSucceeded ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, "We sent an email to", " ", /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall"
    }, email), ". It includes a link that will sign you in.") : /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, "We are unable to send you an email. Please reach out to", " ", /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        typography: "$bodySmall",
        variant: "secondary",
        href: "mailto:contact@opendoor.com",
        onPress: function() {},
        "aria-label": null,
        analyticsName: "".concat(analyticsName, "-passwordless-error-contact-us")
    }, "contact@opendoor.com"), " ", "for support")));
};
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe23.esm.js














//#region src/AccountForm/AccountFormCinderblocks/AccountForm.tsx
var Divider = function() {
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        height: 1,
        backgroundColor: "$borderSecondary",
        width: "100%",
        my: "$4x"
    });
};
var AccountForm = function(_param) {
    var analyticsName = _param.analyticsName, _phone = _param.phone, phone = _phone === void 0 ? "" : _phone, tmp = _param.email, initialEmail = tmp === void 0 ? "" : tmp, tmp1 = _param.name, initialName = tmp1 === void 0 ? "" : tmp1, loginHeaderText = _param.loginHeaderText, registrationHeaderText = _param.registrationHeaderText, loginSubHeaderText = _param.loginSubHeaderText, registrationSubHeaderText = _param.registrationSubHeaderText, emailLoading = _param.emailLoading, passwordLoading = _param.passwordLoading, error = _param.error, phoneNumberInputOptional = _param.phoneNumberInputOptional, phoneNumberInputHidden = _param.phoneNumberInputHidden, openForgotPasswordInNewTab = _param.openForgotPasswordInNewTab, _showGoogleAuth = _param.showGoogleAuth, showGoogleAuth = _showGoogleAuth === void 0 ? false : _showGoogleAuth, overrideHasSubmittedEmailCheckForLogin = _param.overrideHasSubmittedEmailCheckForLogin, emailMismatch = _param.emailMismatch, requestResetPassword = _param.requestResetPassword, _hidePasswordField = _param.hidePasswordField, hidePasswordField = _hidePasswordField === void 0 ? false : _hidePasswordField, onPasswordlessLoginRequest = _param.onPasswordlessLoginRequest, onboardingAccountPageCTA = _param.onboardingAccountPageCTA, fullNamePlaceholder = _param.fullNamePlaceholder, fullNameLabel = _param.fullNameLabel, disclaimerProps = _param.disclaimerProps, passwordFormActionText = _param.passwordFormActionText, onHumanStatusRequest = _param.onHumanStatusRequest, onLogin = _param.onLogin, onRegister = _param.onRegister, postEmailCtaSection = _param.postEmailCtaSection, unsetContainer = _param.unsetContainer, fullNameOptional = _param.fullNameOptional, fullNameHidden = _param.fullNameHidden, googleAuthAnalyticsPrefix = _param.loginAnalyticsPrefix, loginRedirectTo = _param.loginRedirectTo, props = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "phone",
        "email",
        "name",
        "loginHeaderText",
        "registrationHeaderText",
        "loginSubHeaderText",
        "registrationSubHeaderText",
        "emailLoading",
        "passwordLoading",
        "error",
        "phoneNumberInputOptional",
        "phoneNumberInputHidden",
        "openForgotPasswordInNewTab",
        "showGoogleAuth",
        "overrideHasSubmittedEmailCheckForLogin",
        "emailMismatch",
        "requestResetPassword",
        "hidePasswordField",
        "onPasswordlessLoginRequest",
        "onboardingAccountPageCTA",
        "fullNamePlaceholder",
        "fullNameLabel",
        "disclaimerProps",
        "passwordFormActionText",
        "onHumanStatusRequest",
        "onLogin",
        "onRegister",
        "postEmailCtaSection",
        "unsetContainer",
        "fullNameOptional",
        "fullNameHidden",
        "loginAnalyticsPrefix",
        "loginRedirectTo"
    ]);
    var ref = (0,react.useState)(initialEmail), email = ref[0], setEmail = ref[1];
    var emailInputRef = (0,react.useRef)(null);
    var passwordInputRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (emailInputRef.current) emailInputRef.current.focus();
    }, []);
    var ref1 = (0,react.useState)(initialName), name = ref1[0], setName = ref1[1];
    var ref2 = (0,react.useState)(!!props.isNewHuman), isNewHuman = ref2[0], setIsNewHuman = ref2[1];
    var ref3 = (0,react.useState)(!!props.hasGeneratedPassword), hasGeneratedPassword = ref3[0], setHasGeneratedPassword = ref3[1];
    var ref4 = (0,react.useState)(false), googleLoginAttempt = ref4[0], setGoogleLoginAttempt = ref4[1];
    var ref5 = (0,react.useState)(false), isRequestingPasswordlessLogin = ref5[0], setIsRequestingPasswordlessLogin = ref5[1];
    var ref6 = (0,react.useState)(), hasPasswordlessLoginRequestSucceeded = ref6[0], setHasPasswordlessLogingRequestSucceeded = ref6[1];
    var ref7 = (0,react.useContext)(NamelessAccountContext), shouldRegisterOnEmailSubmit = ref7.shouldRegisterOnEmailSubmit, emailRegistrationError = ref7.emailRegistrationError, onAccountUpdate = ref7.onAccountUpdate;
    var handleLogin = function(password) {
        setGoogleLoginAttempt(false);
        onLogin(email, password);
    };
    var handleRegister = function(password, name, phone) {
        setGoogleLoginAttempt(false);
        onRegister(email, name, password, phone);
    };
    var handleEmailSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(email, name) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!onHumanStatusRequest) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onHumanStatusRequest(email, name)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setEmail(email);
                        setName(name !== null && name !== void 0 ? name : "");
                        return [
                            2
                        ];
                }
            });
        });
        return function(email, name) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onHumanStatusRequest
    ]);
    var handleRequestPasswordlessLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var success;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!onPasswordlessLoginRequest) return [
                            3,
                            2
                        ];
                        setIsRequestingPasswordlessLogin(true);
                        return [
                            4,
                            onPasswordlessLoginRequest(email)
                        ];
                    case 1:
                        success = _state.sent().success;
                        setIsRequestingPasswordlessLogin(false);
                        setHasPasswordlessLogingRequestSucceeded(!!success);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRequestPasswordlessLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    var resetValidEmail = function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        setEmail("");
        setHasGeneratedPassword(false);
        setIsNewHuman(false);
    };
    var socialLoginErrorMessage = function(provider, emailMismatch, email) {
        if (emailMismatch && email && email !== "") return "You tried to sign in with an email that isn’t associated with this home address. Please sign in again with ".concat(email, ".");
        return "".concat(provider, " authorization failed. Please try again or use the general login.");
    };
    (0,react.useEffect)(function() {
        setEmail(initialEmail);
        /**
		* If an email was passed check its status so that we can know whether to show
		* the log in or sign up page
		*/ if (initialEmail) handleEmailSubmit(initialEmail);
    }, []);
    (0,react.useEffect)(function() {
        setIsNewHuman(!!props.isNewHuman);
        setHasGeneratedPassword(!!props.hasGeneratedPassword);
    }, [
        props.hasGeneratedPassword,
        props.isNewHuman
    ]);
    var updatingIsNewHuman = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (props.hasGeneratedPassword !== hasGeneratedPassword) setHasGeneratedPassword(!!props.hasGeneratedPassword);
        if (props.isNewHuman !== isNewHuman) {
            setIsNewHuman(!!props.isNewHuman);
            updatingIsNewHuman.current = true;
        }
    }, [
        initialEmail,
        props.hasGeneratedPassword,
        props.isNewHuman
    ]);
    var hasEmailRegisterError = shouldRegisterOnEmailSubmit && !!emailRegistrationError;
    var hasSubmittedEmail = !!(email && email.length > 0 && !emailLoading && !hasEmailRegisterError);
    var skipPasswordPage = isNewHuman && hidePasswordField && fullNameHidden && phoneNumberInputHidden && shouldRegisterOnEmailSubmit && !!onAccountUpdate;
    (0,react.useEffect)(function() {
        if (updatingIsNewHuman.current) {
            updatingIsNewHuman.current = false;
            return;
        }
        if (hasSubmittedEmail && skipPasswordPage) onAccountUpdate(name, phone, false);
    }, [
        hasSubmittedEmail,
        name,
        onAccountUpdate,
        phone,
        skipPasswordPage
    ]);
    if (hasSubmittedEmail && hasGeneratedPassword) return /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountFormWrapper, {
        maxWidth: unsetContainer ? "100%" : 480
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CheckEmailForm, {
        analyticsName: analyticsName,
        email: email,
        hasGeneratedPassword: hasGeneratedPassword,
        onResetValidEmail: resetValidEmail,
        requestResetPassword: requestResetPassword
    }));
    if (hasPasswordlessLoginRequestSucceeded !== void 0) return /* @__PURE__ */ /*#__PURE__*/ react.createElement(PasswordlessResultPage, {
        hasSucceeded: hasPasswordlessLoginRequestSucceeded,
        email: email,
        analyticsName: analyticsName
    });
    var hasGoogleError = googleLoginAttempt && (emailMismatch || error);
    var loginErrorMessage = "";
    if (emailMismatch && email) loginErrorMessage = "You are logged in with an email that isn’t associated with this home address. Please sign in again with ".concat(email, ".");
    else if (error && !googleLoginAttempt) if (error.includes("You have one more attempt before your account is locked.")) loginErrorMessage = "You’ll be locked out after this failed attempt.";
    else if (error.includes("Your account is locked.")) loginErrorMessage = "You’re locked out of your account due to the number of failed password attempts. Check your email to reset your password or try again in 1 hour.";
    else loginErrorMessage = "Invalid email or password";
    var headerText = loginHeaderText != null ? loginHeaderText : "Sign in or create an account";
    if (hasSubmittedEmail && isNewHuman) headerText = registrationHeaderText != null ? registrationHeaderText : "Finish creating an account";
    else if (hasSubmittedEmail) headerText = "Welcome back";
    var showGoogleAuthSection = showGoogleAuth && (!hasSubmittedEmail || overrideHasSubmittedEmailCheckForLogin);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountFormWrapper, {
        maxWidth: unsetContainer ? "100%" : hasSubmittedEmail ? 560 : 400
    }, headerText && /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountFormHeader, null, headerText), !hasSubmittedEmail && (disclaimerProps === null || disclaimerProps === void 0 ? void 0 : disclaimerProps.location) !== "bottom" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(EmailDisclaimerText, {
        analyticsName: analyticsName
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountFormSubHeader, {
        isNewHuman: isNewHuman,
        email: email,
        hasSubmittedEmail: hasSubmittedEmail,
        loginSubHeaderText: loginSubHeaderText,
        registrationSubHeaderText: registrationSubHeaderText,
        onValidEmailReset: resetValidEmail,
        hidePasswordField: hidePasswordField,
        phoneNumberInputHidden: phoneNumberInputHidden
    }), showGoogleAuthSection && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        justifyContent: "center",
        alignItems: "center",
        marginTop: headerText || loginSubHeaderText || registrationSubHeaderText ? "$20x" : 0
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(auth_fe12_esm/* GoogleAuthRedirectButton */.N, {
        analyticsPrefix: googleAuthAnalyticsPrefix,
        redirectTo: loginRedirectTo
    })), hasGoogleError && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ErrorPrompt, {
        message: socialLoginErrorMessage("Google", !!emailMismatch, email)
    }), showGoogleAuthSection && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$4x",
        marginTop: "$20x",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flex: 1
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Divider, null)), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$bodyMedium",
        tag: "p",
        color: "$contentTertiary",
        paddingHorizontal: 7
    }, "or"), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flex: 1
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Divider, null))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(FormWrapper, {
        marginTop: "$20x"
    }, hasSubmittedEmail && !skipPasswordPage ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountPasswordForm, {
        analyticsName: analyticsName,
        email: email,
        name: name,
        phone: phone,
        loading: passwordLoading,
        isNewHuman: isNewHuman,
        loginError: loginErrorMessage,
        onLogin: handleLogin,
        onRegister: handleRegister,
        phoneNumberInputOptional: phoneNumberInputHidden !== null && phoneNumberInputHidden !== void 0 ? phoneNumberInputHidden : false,
        phoneNumberInputHidden: phoneNumberInputHidden,
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        showPasswordlessLogin: !isNewHuman && !!onPasswordlessLoginRequest,
        onRequestPasswordlessLogin: handleRequestPasswordlessLogin,
        isRequestingPasswordlessLogin: isRequestingPasswordlessLogin,
        hidePasswordField: hidePasswordField,
        onboardingAccountPageCTA: onboardingAccountPageCTA,
        fullNamePlaceholder: fullNamePlaceholder ? fullNamePlaceholder : "",
        fullNameLabel: fullNameLabel ? fullNameLabel : "Full name",
        disclaimerProps: disclaimerProps,
        ref: passwordInputRef,
        passwordFormActionText: passwordFormActionText,
        fullNameOptional: fullNameOptional,
        fullNameHidden: fullNameHidden
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$12x"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountEmailForm, {
        analyticsName: analyticsName,
        email: email,
        ref: emailInputRef,
        loading: emailLoading,
        onSubmit: handleEmailSubmit,
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        showForgotPassword: !hidePasswordField
    }), (disclaimerProps === null || disclaimerProps === void 0 ? void 0 : disclaimerProps.location) === "bottom" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(EmailDisclaimerText, {
        analyticsName: analyticsName
    }))));
};
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe24.esm.js


//#region src/AccountForm/AccountFormV2/AccountFormV2.tsx
var AccountFormV2 = function(props) {
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountForm, props);
};
//#endregion


// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Loader/Loader.js + 2 modules
var Loader = __webpack_require__(89682);
;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe25.esm.js







//#region src/AccountForm/AccountForm.tsx
var auth_fe25_esm_AccountForm = function(param) {
    var accountFormProps = param.accountFormProps, featureFlagProps = param.featureFlagProps;
    var _flag = featureFlagProps.flag, flag = _flag === void 0 ? "auth-fe-account-form" : _flag, _loading = featureFlagProps.loading, loading = _loading === void 0 ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Loader/* Loader */.a, {
        size: "small"
    }) : _loading, flagProps = (0,_object_without_properties/* default */.Z)(featureFlagProps, [
        "flag",
        "loading"
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(AsyncFeatureFlagGate, (0,_object_spread/* default */.Z)({
        flag: flag,
        disabled: /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountForm, accountFormProps),
        enabled: /* @__PURE__ */ /*#__PURE__*/ react.createElement(AccountFormV2, accountFormProps),
        loading: loading
    }, flagProps));
};
//#endregion



/***/ }),

/***/ 73585:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ __exportAll; }
/* harmony export */ });
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
//#endregion



/***/ }),

/***/ 91526:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ RECEIVE_SESSION_INFO; },
/* harmony export */   "E7": function() { return /* binding */ LOGGED_OUT; },
/* harmony export */   "HS": function() { return /* binding */ SUCCESS_REGISTER; },
/* harmony export */   "Hz": function() { return /* binding */ BEGIN_REGISTER; },
/* harmony export */   "KL": function() { return /* binding */ REQUEST_HUMAN_STATUS; },
/* harmony export */   "Nz": function() { return /* binding */ REGISTER; },
/* harmony export */   "O8": function() { return /* binding */ actionTypes_exports; },
/* harmony export */   "R0": function() { return /* binding */ ERROR_REQUEST_RESET_PASSWORD; },
/* harmony export */   "U3": function() { return /* binding */ TRACK_EVENT; },
/* harmony export */   "Vz": function() { return /* binding */ MAYBE_FETCH_SESSION_INFO; },
/* harmony export */   "c9": function() { return /* binding */ BEGIN_REQUEST_HUMAN_STATUS; },
/* harmony export */   "ix": function() { return /* binding */ MAYBE_LOG_OUT; },
/* harmony export */   "jd": function() { return /* binding */ SUCCESS_REQUEST_HUMAN_STATUS; },
/* harmony export */   "ji": function() { return /* binding */ BEGIN_LOG_IN; },
/* harmony export */   "km": function() { return /* binding */ FETCH_SESSION_INFO; },
/* harmony export */   "kw": function() { return /* binding */ ERROR_REGISTER; },
/* harmony export */   "me": function() { return /* binding */ BEGIN_LOADING_SESSION_INFO; },
/* harmony export */   "pd": function() { return /* binding */ SUCCESS_LOG_IN; },
/* harmony export */   "rd": function() { return /* binding */ REQUEST_RESET_PASSWORD; },
/* harmony export */   "sh": function() { return /* binding */ BEGIN_REQUEST_RESET_PASSWORD; },
/* harmony export */   "tD": function() { return /* binding */ SUCCESS_REQUEST_RESET_PASSWORD; },
/* harmony export */   "v3": function() { return /* binding */ ERROR_SESSION_INFO; },
/* harmony export */   "vH": function() { return /* binding */ ERROR_REQUEST_HUMAN_STATUS; },
/* harmony export */   "wq": function() { return /* binding */ ERROR_LOG_IN; },
/* harmony export */   "xr": function() { return /* binding */ LOG_IN; }
/* harmony export */ });
/* harmony import */ var _virtual_rolldown_runtime_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73585);

//#region src/store/session/actionTypes.ts
var actionTypes_exports = /* @__PURE__ */ (0,_virtual_rolldown_runtime_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__exportAll */ .f)({
	BEGIN_LOADING_SESSION_INFO: () => BEGIN_LOADING_SESSION_INFO,
	BEGIN_LOG_IN: () => BEGIN_LOG_IN,
	BEGIN_REGISTER: () => BEGIN_REGISTER,
	BEGIN_REQUEST_HUMAN_STATUS: () => BEGIN_REQUEST_HUMAN_STATUS,
	BEGIN_REQUEST_RESET_PASSWORD: () => BEGIN_REQUEST_RESET_PASSWORD,
	ERROR_LOG_IN: () => ERROR_LOG_IN,
	ERROR_REGISTER: () => ERROR_REGISTER,
	ERROR_REQUEST_HUMAN_STATUS: () => ERROR_REQUEST_HUMAN_STATUS,
	ERROR_REQUEST_RESET_PASSWORD: () => ERROR_REQUEST_RESET_PASSWORD,
	ERROR_SESSION_INFO: () => ERROR_SESSION_INFO,
	FETCH_SESSION_INFO: () => FETCH_SESSION_INFO,
	LOGGED_OUT: () => LOGGED_OUT,
	LOG_IN: () => LOG_IN,
	MAYBE_FETCH_SESSION_INFO: () => MAYBE_FETCH_SESSION_INFO,
	MAYBE_LOG_OUT: () => MAYBE_LOG_OUT,
	RECEIVE_SESSION_INFO: () => RECEIVE_SESSION_INFO,
	REGISTER: () => REGISTER,
	REQUEST_HUMAN_STATUS: () => REQUEST_HUMAN_STATUS,
	REQUEST_RESET_PASSWORD: () => REQUEST_RESET_PASSWORD,
	SUCCESS_LOG_IN: () => SUCCESS_LOG_IN,
	SUCCESS_REGISTER: () => SUCCESS_REGISTER,
	SUCCESS_REQUEST_HUMAN_STATUS: () => SUCCESS_REQUEST_HUMAN_STATUS,
	SUCCESS_REQUEST_RESET_PASSWORD: () => SUCCESS_REQUEST_RESET_PASSWORD,
	TRACK_EVENT: () => TRACK_EVENT
});
var MAYBE_FETCH_SESSION_INFO = "@@od/store/session/maybeFetchSessionInfo";
var FETCH_SESSION_INFO = "@@od/store/session/fetchSessionInfo";
var BEGIN_LOADING_SESSION_INFO = "@@od/store/session/beginLoadingSessionInfo";
var RECEIVE_SESSION_INFO = "@@od/store/session/receiveSessionInfo";
var ERROR_SESSION_INFO = "@@od/store/session/errorSessionInfo";
var BEGIN_LOG_IN = "@@od/store/session/beginLogIn";
var ERROR_LOG_IN = "@@od/store/session/errorLogIn";
var LOG_IN = "@@od/store/session/logIn";
var SUCCESS_LOG_IN = "@@od/store/session/successLogIn";
var BEGIN_REQUEST_HUMAN_STATUS = "@@od/store/session/beginRequestHumanStatus";
var ERROR_REQUEST_HUMAN_STATUS = "@@od/store/session/errorRequestHumanStatus";
var REQUEST_HUMAN_STATUS = "@@od/store/session/requestHumanStatus";
var SUCCESS_REQUEST_HUMAN_STATUS = "@@od/store/session/successRequestHumanStatus";
var BEGIN_REQUEST_RESET_PASSWORD = "@@od/store/session/beginRequestPasswordReset";
var ERROR_REQUEST_RESET_PASSWORD = "@@od/store/session/errorRequestPasswordReset";
var REQUEST_RESET_PASSWORD = "@@od/store/session/requestPasswordReset";
var SUCCESS_REQUEST_RESET_PASSWORD = "@@od/store/session/successRequestPasswordReset";
var BEGIN_REGISTER = "@@od/store/session/beginRegister";
var ERROR_REGISTER = "@@od/store/session/errorRegister";
var REGISTER = "@@od/store/session/register";
var SUCCESS_REGISTER = "@@od/store/session/successRegister";
var MAYBE_LOG_OUT = "@@od/store/session/maybeLogOut";
var LOGGED_OUT = "@@od/store/session/loggedOut";
var TRACK_EVENT = "@@od/store/session/trackEvent";
//#endregion


//# sourceMappingURL=actionTypes.mjs.map

/***/ }),

/***/ 5868:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ib": function() { return /* binding */ logIn; },
/* harmony export */   "Js": function() { return /* binding */ successLogIn; },
/* harmony export */   "Jx": function() { return /* binding */ successRequestHumanStatus; },
/* harmony export */   "Km": function() { return /* binding */ successRequestPasswordReset; },
/* harmony export */   "Kq": function() { return /* binding */ beginRegister; },
/* harmony export */   "MI": function() { return /* binding */ errorSessionInfo; },
/* harmony export */   "NY": function() { return /* binding */ actions_exports; },
/* harmony export */   "P7": function() { return /* binding */ errorRequestHumanStatus; },
/* harmony export */   "T7": function() { return /* binding */ errorRegister; },
/* harmony export */   "TM": function() { return /* binding */ fetchSessionInfo; },
/* harmony export */   "V1": function() { return /* binding */ successRegister; },
/* harmony export */   "_f": function() { return /* binding */ beginRequestPasswordReset; },
/* harmony export */   "aO": function() { return /* binding */ maybeLogOut; },
/* harmony export */   "by": function() { return /* binding */ requestHumanStatus; },
/* harmony export */   "d3": function() { return /* binding */ maybeFetchSessionInfo; },
/* harmony export */   "f8": function() { return /* binding */ requestPasswordReset; },
/* harmony export */   "fC": function() { return /* binding */ beginLoadingSessionInfo; },
/* harmony export */   "i": function() { return /* binding */ beginRequestHumanStatus; },
/* harmony export */   "jb": function() { return /* binding */ errorRequestPasswordReset; },
/* harmony export */   "k4": function() { return /* binding */ loggedOut; },
/* harmony export */   "tc": function() { return /* binding */ beginLogIn; },
/* harmony export */   "x5": function() { return /* binding */ errorLogIn; },
/* harmony export */   "z2": function() { return /* binding */ register; },
/* harmony export */   "zn": function() { return /* binding */ receiveSessionInfo; }
/* harmony export */ });
/* unused harmony export trackEvent */
/* harmony import */ var _virtual_rolldown_runtime_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73585);
/* harmony import */ var _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91526);


//#region src/store/session/actions.ts
var actions_exports = /* @__PURE__ */ (0,_virtual_rolldown_runtime_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__exportAll */ .f)({
	beginLoadingSessionInfo: () => beginLoadingSessionInfo,
	beginLogIn: () => beginLogIn,
	beginRegister: () => beginRegister,
	beginRequestHumanStatus: () => beginRequestHumanStatus,
	beginRequestPasswordReset: () => beginRequestPasswordReset,
	errorLogIn: () => errorLogIn,
	errorRegister: () => errorRegister,
	errorRequestHumanStatus: () => errorRequestHumanStatus,
	errorRequestPasswordReset: () => errorRequestPasswordReset,
	errorSessionInfo: () => errorSessionInfo,
	fetchSessionInfo: () => fetchSessionInfo,
	logIn: () => logIn,
	loggedOut: () => loggedOut,
	maybeFetchSessionInfo: () => maybeFetchSessionInfo,
	maybeLogOut: () => maybeLogOut,
	receiveSessionInfo: () => receiveSessionInfo,
	register: () => register,
	requestHumanStatus: () => requestHumanStatus,
	requestPasswordReset: () => requestPasswordReset,
	successLogIn: () => successLogIn,
	successRegister: () => successRegister,
	successRequestHumanStatus: () => successRequestHumanStatus,
	successRequestPasswordReset: () => successRequestPasswordReset,
	trackEvent: () => trackEvent
});
function maybeFetchSessionInfo() {
	return {
		payload: {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .MAYBE_FETCH_SESSION_INFO */ .Vz
	};
}
function fetchSessionInfo() {
	return {
		payload: {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .FETCH_SESSION_INFO */ .km
	};
}
function beginLoadingSessionInfo() {
	return {
		payload: {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .BEGIN_LOADING_SESSION_INFO */ .me
	};
}
function receiveSessionInfo(info) {
	return {
		payload: { info },
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .RECEIVE_SESSION_INFO */ .$l
	};
}
function errorSessionInfo(error) {
	return {
		payload: { error },
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_SESSION_INFO */ .v3
	};
}
function beginLogIn() {
	return {
		payload: {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .BEGIN_LOG_IN */ .ji
	};
}
function errorLogIn(error, statusCode) {
	return {
		payload: {
			error,
			statusCode
		},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_LOG_IN */ .wq
	};
}
function logIn(email, password, googleIDToken, facebookIDToken) {
	return {
		payload: {
			email,
			password,
			googleIDToken,
			facebookIDToken
		},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .LOG_IN */ .xr
	};
}
function successLogIn(serverLoginRedirect) {
	return {
		payload: serverLoginRedirect ? { serverLoginRedirect } : {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_LOG_IN */ .pd
	};
}
function beginRequestHumanStatus() {
	return {
		payload: {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .BEGIN_REQUEST_HUMAN_STATUS */ .c9
	};
}
function errorRequestHumanStatus(error, statusCode) {
	return {
		payload: {
			error,
			statusCode
		},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_REQUEST_HUMAN_STATUS */ .vH
	};
}
function requestHumanStatus(email) {
	return {
		payload: { email },
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .REQUEST_HUMAN_STATUS */ .KL
	};
}
function successRequestHumanStatus(email, hasGeneratedPassword, isNewHuman = false) {
	return {
		payload: {
			email,
			hasGeneratedPassword,
			isNewHuman
		},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REQUEST_HUMAN_STATUS */ .jd
	};
}
function beginRequestPasswordReset() {
	return {
		payload: {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .BEGIN_REQUEST_RESET_PASSWORD */ .sh
	};
}
function errorRequestPasswordReset(error, statusCode) {
	return {
		payload: {
			error,
			statusCode
		},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_REQUEST_RESET_PASSWORD */ .R0
	};
}
function requestPasswordReset(email) {
	return {
		payload: { email },
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .REQUEST_RESET_PASSWORD */ .rd
	};
}
function successRequestPasswordReset(email, hasGeneratedPassword, isNewHuman = false) {
	return {
		payload: {
			email,
			hasGeneratedPassword,
			isNewHuman
		},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REQUEST_RESET_PASSWORD */ .tD
	};
}
function beginRegister() {
	return {
		payload: {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .BEGIN_REGISTER */ .Hz
	};
}
function errorRegister(error) {
	return {
		payload: { error },
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_REGISTER */ .kw
	};
}
function register(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl) {
	return {
		payload: {
			email,
			name,
			password,
			phone,
			googleIDToken,
			facebookIDToken,
			passwordlessToken,
			hasGeneratedPassword,
			redirectUrl
		},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .REGISTER */ .Nz
	};
}
function successRegister(serverLoginRedirect) {
	return {
		payload: serverLoginRedirect ? { serverLoginRedirect } : {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .SUCCESS_REGISTER */ .HS
	};
}
function maybeLogOut() {
	return {
		payload: {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .MAYBE_LOG_OUT */ .ix
	};
}
function loggedOut() {
	return {
		payload: {},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .LOGGED_OUT */ .E7
	};
}
var trackEvent = (category, action, label, extra) => {
	return {
		payload: {
			category,
			action,
			label,
			extra
		},
		type: _actionTypes_mjs__WEBPACK_IMPORTED_MODULE_1__/* .TRACK_EVENT */ .U3
	};
};
//#endregion


//# sourceMappingURL=actions.mjs.map

/***/ }),

/***/ 30405:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ email; },
/* harmony export */   "Jv": function() { return /* binding */ infoIsLoaded; },
/* harmony export */   "PQ": function() { return /* binding */ hasGeneratedPassword; },
/* harmony export */   "Pl": function() { return /* binding */ loggedIn; },
/* harmony export */   "Sm": function() { return /* binding */ resetPasswordRequestStatus; },
/* harmony export */   "et": function() { return /* binding */ loginRequestStatus; },
/* harmony export */   "jo": function() { return /* binding */ registrationRequestStatus; },
/* harmony export */   "oq": function() { return /* binding */ isNewHuman; },
/* harmony export */   "p6": function() { return /* binding */ infoIsLoading; },
/* harmony export */   "tH": function() { return /* binding */ humanStatusRequestStatus; },
/* harmony export */   "xu": function() { return /* binding */ serverLoginRedirect; },
/* harmony export */   "y1": function() { return /* binding */ human; }
/* harmony export */ });
//#region src/store/session/selectors.ts
var infoIsLoading = (state) => state.getIn ? state.getIn(["session", "infoIsLoading"]) : state.session.getIn(["infoIsLoading"]);
var infoIsLoaded = (state) => state.getIn ? state.getIn(["session", "infoIsLoaded"]) : state.session.getIn(["infoIsLoaded"]);
var human = (state) => state.getIn ? state.getIn([
	"session",
	"info",
	"human"
]) : state.session.getIn(["info", "human"]);
var loggedIn = (state) => state.getIn ? state.getIn([
	"session",
	"info",
	"logged_in"
], false) : state.session.getIn(["info", "logged_in"], false);
var loginRequestStatus = (state) => state.getIn ? state.getIn(["session", "loginRequestStatus"]).toJSON() : state.session.getIn(["loginRequestStatus"]).toJSON();
var registrationRequestStatus = (state) => state.getIn ? state.getIn(["session", "registrationRequestStatus"]).toJSON() : state.session.getIn(["registrationRequestStatus"]).toJSON();
var serverLoginRedirect = (state) => state.getIn ? state.getIn(["session", "serverLoginRedirect"]) : state.session.getIn(["serverLoginRedirect"]);
var email = (state) => state.getIn ? state.getIn(["session", "email"]) : state.session.getIn(["email"]);
var hasGeneratedPassword = (state) => state.getIn ? state.getIn(["session", "hasGeneratedPassword"]) : state.session.getIn(["hasGeneratedPassword"]);
var isNewHuman = (state) => state.getIn ? state.getIn(["session", "isNewHuman"]) : state.session.getIn(["isNewHuman"]);
var humanStatusRequestStatus = (state) => state.getIn ? state.getIn(["session", "humanStatusRequestStatus"]).toJSON() : state.session.getIn(["humanStatusRequestStatus"]).toJSON();
var resetPasswordRequestStatus = (state) => state.getIn ? state.getIn(["session", "resetPasswordRequestStatus"]).toJSON() : state.session.getIn(["resetPasswordRequestStatus"]).toJSON();
//#endregion


//# sourceMappingURL=selectors.mjs.map

/***/ })

}]);